import { Zap } from "lucide-react";
import { platformBranding } from "@/config/restaurantConfig";
import { useLang } from "@/context/LanguageContext";

// The NFC/tap signal mark tile (brand gradient). Reused across the app.
export function BrandMark({ size = 38 }) {
  return (
    <div
      className="relative grid shrink-0 place-items-center rounded-[30%] brand-gradient shadow-soft"
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 24 24" width={size * 0.62} height={size * 0.62} fill="none" className="text-white">
        <path d="M5 15.5c1.2-1.4 3-2.3 5-2.3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.55" />
        <path d="M5 11.5c2.2-2.4 5.3-3.9 8.6-3.9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.8" />
        <path d="M5 7.6C8.1 4.4 12.4 2.5 17 2.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="5.3" cy="18.7" r="1.6" fill="currentColor" />
      </svg>
    </div>
  );
}

// FudiTap platform wordmark (Fudi = foreground, Tap = gradient).
export function Logo({ size = "md", showWord = true }) {
  const dim = size === "sm" ? 30 : size === "lg" ? 48 : 38;
  const text = size === "sm" ? "text-lg" : size === "lg" ? "text-3xl" : "text-xl";
  return (
    <div className="flex items-center gap-2.5" data-testid="fuditap-logo">
      <BrandMark size={dim} />
      {showWord && (
        <span className={`font-heading font-extrabold tracking-tight ${text}`}>
          <span className="text-foreground">Fudi</span>
          <span className="brand-text">Tap</span>
        </span>
      )}
    </div>
  );
}

// Restaurant (tenant) brand lockup: logo image if configured, else mark + name.
export function RestaurantBrand({ name, branch, logoImage, size = 34 }) {
  return (
    <div className="flex min-w-0 items-center gap-2.5" data-testid="restaurant-brand">
      {logoImage ? (
        <img src={logoImage} alt={name} className="h-9 w-auto max-w-[140px] object-contain" />
      ) : (
        <>
          <BrandMark size={size} />
          <div className="min-w-0 leading-tight">
            <p className="truncate font-heading text-base font-extrabold">{name}</p>
            {branch && <p className="truncate text-[11px] text-muted-foreground">{branch}</p>}
          </div>
        </>
      )}
    </div>
  );
}

export function PoweredByFudiTap() {
  const { t } = useLang();
  return (
    <div className="flex items-center justify-center gap-1.5 py-6 text-xs text-muted-foreground" data-testid="powered-by">
      <Zap className="h-3.5 w-3.5 text-primary" />
      <span>
        {t("poweredBy")} <span className="font-semibold brand-text">{platformBranding.name}</span>
      </span>
    </div>
  );
}
